import { v4 as uuid } from 'uuid';
import workerUrl from './workerInterval.worker?worker&url';
import IntervalWork from './workerInterval.worker';

// const workerFactory = (workerScript: URL, workerOptions: WorkerOptions) => () =>
//     new Worker(workerScript, workerOptions);
// const factory = workerFactory(
//     new URL('./workerInterval.worker.ts', import.meta.url),
//     {
//         type: 'module',
//     }
// );

export interface Work {
    id: string;
    callback: () => void;
}

/*
 * Borrowed from https://github.com/gorkemcnr/worker-interval but with inline=fallback added to the
 * import to allow for Blob fallback in unsupported browsers (such as Embedded Chromium in Newport)
 */
export default class WorkerInterval {
    private works: Work[] = [];
    private readonly worker: Worker;

    public constructor() {
        this.worker = new Worker(workerUrl, { type: 'module' });
        this.worker.onmessage = (data) => this.onMessage(data);
    }

    public setInterval(callback: () => void, delay: number): string | null {
        const work: Work = {
            id: uuid(),
            callback,
        };

        this.works.push(work);

        const intervalWork: IntervalWork = {
            name: 'setInterval',
            id: work.id,
            delay,
        };

        this.worker.postMessage(intervalWork);

        return work.id;
    }

    public clearInterval(id: string): void {
        const workIndex =
            this.works && this.works.findIndex((x) => x.id === id);
        if (workIndex === null || workIndex < 0) {
            return;
        }

        const intervalWork: IntervalWork = {
            name: 'clearInterval',
            id: this.works[workIndex].id,
        };

        this.worker.postMessage(intervalWork);
        this.works.splice(workIndex, 1);
    }

    private onMessage(event: MessageEvent): void {
        const intervalWork = event.data && (event.data as IntervalWork);
        if (!intervalWork) {
            return;
        }

        switch (intervalWork.name) {
            case 'runCallback': {
                const work =
                    this.works &&
                    this.works.find((x) => x.id === intervalWork.id);
                if (!work) {
                    return;
                }

                work.callback();
                break;
            }
        }
    }
}
